import IconShieldPerson from '@/shared/icons/NewDesign/IconShieldPerson'
import IconTune from '@/shared/icons/NewDesign/IconTune'
import IconBolt from '@/shared/icons/NewDesign/IconBolt'
import IconLocked from '@/shared/icons/NewDesign/IconLocked'

export const devToolsSections = [
  { key: 'contacts', labelKey: 'common.routes.contacts', Icon: IconShieldPerson },
  { key: 'feedback', labelKey: 'common.routes.feedback', Icon: IconTune },
  { key: 'commands', labelKey: 'common.routes.commands', Icon: IconBolt },
  { key: 'cache', labelKey: 'common.routes.cache', Icon: IconLocked },
]
